export const collaborationStatusId = {
    CART: 0,
    ACCEPTANCE_PENDING: 1,
    DECLINED: 2,
    ACCEPTED: 3,
    CANCELLED: 4,
    CLOSED: 5,
}